<template>
  <div>
    <loading :active.sync="isLoading"
             :is-full-page="fullPage"
             color="#00F">
    </loading>

    <vue-snotify></vue-snotify>
    <b-row>
      <b-col cols="12">
        <div class="animated fadeIn">
          <b-row>
            <b-col sm="12">
              <Vuetable
                  class="table table-striped table-bordered nowrap vue-tbl"
                  ref="Vuetable"
                  :api-url="getUrl"
                  :http-options="httpOptions"
                  :fields="fields"
                  pagination-path
                  @vuetable:pagination-data="onPaginationData"
                  @vuetable:loaded="loaded"
                  :append-params="moreParams"
                  :per-page="perPage"
                  :row-class="onRowClass"
              >

                <template slot="customer_view_status" scope="props">
                  <div class='badge badge-primary badge-pill'>{{props.rowData.proposal_status_value}}</div> <br>
                  <div v-bind:class="{primary:props.rowData.customer_view_status == 1}" class='badge badge-success badge-pill'>{{props.rowData.customer_view_status == 1 ? 'seen' : '' }}<i v-if="props.rowData.customer_view_status == 1" class="nav-icon icon-bulb"></i></div>
                </template>


                <template slot="actions" scope="props">
                  <div class="custom-actions">
                    <b-button v-if="props.rowData.status == 2"
                              class="btn btn-success btn-sm"
                              @click="onActionClicked(
                                                        'send-link',
                                                        props.rowData,
                                                        props.rowIndex
                                                      )">
                      <i class="icon-share-alt"> Resend link</i>
                    </b-button>

                    <b-button v-if="[5,10].indexOf(props.rowData.status) >= 0"
                              class="btn btn-success btn-sm"
                              @click="onActionClicked(
                                                        'resend-customer-signature-link',
                                                        props.rowData,
                                                        props.rowIndex
                                                      )"><i class="icon-share-alt"> Resend Signature link</i>
                    </b-button>

                    <b-button v-if="props.rowData.status == 7"
                              class="btn btn-warning btn-sm"
                              @click="
                                                      onActionClicked(
                                                        'download-pdf',
                                                        props.rowData,
                                                        props.rowIndex,
                                                        true
                                                      )">
                      <i class="cui-cloud-download"> Download</i>
                    </b-button>

                    <b-button v-if="[9,8,1].indexOf(props.rowData.status) >= 0"
                              class="btn btn-primary btn-sm"
                              @click="
                                                      onActionClicked(
                                                        'edit-item',
                                                        props.rowData,
                                                        props.rowIndex,
                                                        true
                                                      )">
                      <i class="icon-pencil"> Edit</i>
                    </b-button>

                    <b-button v-if="[6,11].indexOf(props.rowData.status) >= 0"
                              class="btn btn-primary btn-sm"
                              @click="
                                                      onActionClicked(
                                                        'clone-item',
                                                        props.rowData,
                                                        props.rowIndex,
                                                        true
                                                      )">
                      <i class="icon-pencil"> Clone</i>
                    </b-button>

                  </div>
                </template>
              </Vuetable>

              <b-row>
                <b-col>
                  <div class="vuetable-pagination ui basic segment grid row">
                    <b-col cols="4">
                      <vuetable-pagination-info
                          ref="paginationInfo"
                      ></vuetable-pagination-info>
                    </b-col>
                    <b-col cols="8">
                      <vuetable-pagination
                          style="float:right;"
                          ref="pagination"
                          @vuetable-pagination:change-page="onChangePage"
                      ></vuetable-pagination>
                    </b-col>
                  </div>
                </b-col>
              </b-row>


            </b-col>
          </b-row>
        </div>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import Vue from "vue";
import {mapState, mapActions, mapGetters} from "vuex";
import Vuetable from "vuetable-2/src/components/Vuetable";
import VuetablePaginationInfo from "vuetable-2/src/components/VuetablePaginationInfo";
import VuetablePagination from "@/components/vuetable/VuetablePaginationBootstrap4";
import {http} from "@/config/http";

export default {
  name: "Quotationtable",
  components: {
    Vuetable,
    VuetablePagination,
    VuetablePaginationInfo
  },
  data() {
    return {
      isLoading: false,
      fullPage: true,
      uuid: '',
      httpOptions: {
        headers: {
          "Content-Type": "application/json;charset=UTF-8",
          Accept: "application/json",
          Authorization: "Bearer " + localStorage.getItem("access_token")
        },
        data: {}
      },
      moreParams: {
        uuid: this.uuid
      },
      getUrl: process.env.VUE_APP_API_ENDPOINT + "proposal/list",
      fields: [
        {
          name: "id",
          title: '<span class="orange glyphicon glyphicon-user"></span> #',
          sortField: "id"
        },
        {
          name: "proposal_no",
          title:
              '<span class="orange glyphicon glyphicon-user"></span> Proposal No',
          sortField: "proposal_no",
          callback: "return_proposal_no"
        },
        {
          name: "vehicle_number",
          title:
              '<span class="orange glyphicon glyphicon-user"></span> Vehicle No',
          sortField: "vehicle_number",
          callback: "return_vehicle_no"
        },
        {
          name: "contact_no_mobile",
          title:
              '<span class="orange glyphicon glyphicon-user"></span> Customer Contact No',
          sortField: "contact_no_mobile",
        },
        {
          name: "created_at",
          title: '<span class="orange glyphicon glyphicon-user"></span> Date',
          sortField: "created_at"
        },
        {
          name: "created_by_user.full_name",
          title: '<span class="orange glyphicon glyphicon-user"></span> User',
          sortField: "created_by_user.full_name"
        },
        // {
        //   name: "proposal_status_value",
        //   title:
        //       '<span class="orange glyphicon glyphicon-user"></span> Status',
        //   sortField: "proposal_status_value",
        //   callback: "return_proposal_status_value"
        // },
        {
          name: "__slot:customer_view_status",
          title: '<span class="orange glyphicon glyphicon-user"></span> Status',
          width: '190px'
        },
        {
          name: "__slot:actions",
          title: '<span class="orange glyphicon glyphicon-user"></span> Action',
          width: '190px'
        }
      ],
      data: [],
      perPage: 10,
      sortOrder: [],
      filterText: ""
    };
  },
  methods: {
    ...mapActions("proposal", [
      "cloneProposalData",
      "getProposalData",
      "downloadPdf"
    ]),
    loaded() {
      setTimeout(function () {
        this.isLoading = false;
      }.bind(this), 300);
    },
    return_proposal_status_value(status) {
      return "<div class='badge badge-primary badge-pill'>" + status + "</div>";
    },
    return_proposal_no(proposal_no) {
      if (proposal_no) {
        return proposal_no;
      } else {
        return 'N/A';
      }
    },
    return_vehicle_no(vehicle_no) {
      if (vehicle_no) {
        return vehicle_no;
      } else {
        return 'N/A';
      }
    },
    onPaginationData(paginationData) {
      this.$refs.pagination.setPaginationData(paginationData);
      this.$refs.paginationInfo.setPaginationData(paginationData);
    },
    onChangePage(page) {
      this.$refs.Vuetable.changePage(page);
    },
    onFilterSet(filters) {
      this.isLoading = true;
      this.moreParams = {
        proposal_status: filters.proposal_status,
        proposal_number: filters.proposal_number,
        vehicle_number: filters.vehicle_number,
        insurance_type: filters.insurance_type,
        user_account: filters.user_account,
        date: filters.date
      };
      Vue.nextTick(() => this.$refs.Vuetable.refresh());
    },
    onFilterReset() {
      this.isLoading = true;
      this.moreParams = {};
      Vue.nextTick(() => this.$refs.Vuetable.refresh());
    },
    onRowClass(dataItem , index){
       if(dataItem.status == 7){
         return 'table-success';
       }else if(  [8,9,2,5].indexOf(dataItem.status) >= 0){
         return 'table-warning';
       }else if(  [6,11].indexOf(dataItem.status) >= 0){
         return 'table-danger';
       } else if(  [12].indexOf(dataItem.status) >= 0){
         return 'table-secondary';
       }else{

       }
    },
    onActionClicked(action, data, rowIndex, pdf = false) {

      const filterData = {
        proposal_id_inc: data.id
      };
      this.getProposalData(filterData).then((response) => {
        if (!response.error) {
          let proposal_status = response.data.data.proposal_status;

          if (action == "send-link") {

            this.$confirm("Are you sure want to resend the link?").then(() => {
              if ([2].indexOf(proposal_status) >= 0) {
                this.isLoading = true;
                http
                    .post("proposal/send_link", {proposal_id: data.id})
                    .then(response => {
                      this.$snotify
                          .success(response.data.message, "", {
                            position: "centerTop",
                          });
                      this.isLoading = false;
                    })
                    .catch(error => {
                      commit(
                          "showAlert",
                          {
                            title: "Error!",
                            msg: "Error occured while creating user.",
                            type: "error",
                            position: "rightTop"
                          },
                          {root: true}
                      );
                      this.isLoading = false;
                    });
              } else {
                this.$snotify
                    .error("Access Denied", "", {
                      position: "centerTop",
                    });
                Vue.nextTick(() => this.$refs.Vuetable.refresh());
              }
            });

          } else if (action == "edit-item") {

            if ([9, 8, 1].indexOf(proposal_status) >= 0) {
              this.$router.push({
                name: 'ProposalEdit', query: {
                  id: data.hash_id_value
                }
              })
            } else {
              this.$snotify
                  .error("Access Denied", "", {
                    position: "centerTop",
                  });
              Vue.nextTick(() => this.$refs.Vuetable.refresh());
            }


          } else if (action == "clone-item") {
            if ([6, 11].indexOf(proposal_status) >= 0) {
              const params = {
                proposal_id: data.id,
              };
              this.cloneProposalData(params).then((response) => {
                if (!response.error) {
                  this.$snotify
                      .success(response.data.message, "", {
                        position: "centerTop",
                      })
                      .on("destroyed", () => {
                            this.$refs.Vuetable.refresh();
                          }
                      );
                }
              });
            } else {
              this.$snotify
                  .error("Access Denied", "", {
                    position: "centerTop",
                  });
              Vue.nextTick(() => this.$refs.Vuetable.refresh());
            }
          } else if (action == "download-pdf") {
            this.isLoading = true;
            if ([7].indexOf(proposal_status) >= 0) {
              const params = {
                proposal_id: data.id,
              };
              this.downloadPdf(params).then((response) => {
                if (!response.error) {
                  this.isLoading = false;
                  this.$snotify
                      .success(response.data.message, "", {
                        position: "centerTop",
                      })
                      .on("destroyed", () => {
                            this.$refs.Vuetable.refresh();
                            window.open(
                                process.env.VUE_APP_UPLOAD_PDF_PATH +
                                response.data.data,
                                "_blank"
                            );
                          }
                      );
                }
              });
            } else {
              this.$snotify
                  .error("Access Denied", "", {
                    position: "centerTop",
                  });
              Vue.nextTick(() => this.$refs.Vuetable.refresh());
            }
          } else if (action == "resend-customer-signature-link") {

            if ([5].indexOf(proposal_status) >= 0) {
              this.$confirm("Are you sure want to resend the signature link?").then(() => {
                this.isLoading = true;
                http
                    .post("proposal/get_customer_signature", {proposal_id: data.id})
                    .then(response => {
                      if (response.error) {
                        this.isLoading = false;
                        this.$snotify
                            .success(response.data.message, "", {
                              position: "centerTop",
                            });
                      } else {
                        this.isLoading = false;
                        this.$snotify
                            .success(response.data.message, "", {
                              position: "centerTop",
                            });
                      }
                    })
                    .catch(error => {
                      commit(
                          "showAlert",
                          {
                            title: "Error!",
                            msg: "Error occured while sending sms",
                            type: "error",
                            position: "rightTop"
                          },
                          {root: true}
                      );
                    });
              });
            }else{
              this.$snotify
                  .error("Access Denied", "", {
                    position: "centerTop",
                  });
              Vue.nextTick(() => this.$refs.Vuetable.refresh());
            }
          }
        } else {
          Vue.nextTick(() => this.$refs.Vuetable.refresh());
        }
      });

    }

  },
  watch: {
    data(newVal, oldVal) {
      this.$refs.Vuetable.refresh();
    },
  },

  computed: {
    ...mapState("proposal", [
      "ActionData",
    ]),
    ...mapState("login", ["system_role"]),
  },


  mounted() {
    this.isLoading = true;
    this.$events.$on("filter-set", eventData => this.onFilterSet(eventData));
    this.$events.$on("filter-reset", e => this.onFilterReset());
    if (this.$route.query.uuid) {
      this.uuid = this.$route.query.uuid;
    }
    if(this.system_role == 4){
      this.$router.push({
        name: 'AccessDenied'
      });
    }

  },


};
</script>

<style scoped>
.card-body >>> table > tbody > tr > td {
  cursor: pointer;
}

.custom-actions .btn {
  width: 100%;
}

table-bordered th {
  border: none;
}

thead {
  color: white;
  background-color: #044066;
}

</style>
